<video #video></video>
<br>
<br>
<select [(ngModel)]="selectedCamera" (change)="onCameraSelect(selectedCamera)">
  <option *ngFor="let camera of cameras" [ngValue]="camera">{{camera.label}}</option>
</select>
<br>
<br>
